// -- AUTO GENERATED FILE; DO NOT MODIFY --
import AlphaGoat01 from "@/pages/AlphaGoat/AlphaGoat01.vue";
import AlphaGoat01S2 from "@/pages/AlphaGoat/AlphaGoat01S2.vue";
import AlphaGoat01S3 from "@/pages/AlphaGoat/AlphaGoat01S3.vue";
import AlphaGoat01S4 from "@/pages/AlphaGoat/AlphaGoat01S4.vue";
import AlphaGoat01Tiers from "@/pages/AlphaGoat/AlphaGoat01Tiers.vue";
import AlphaGoat02 from "@/pages/AlphaGoat/AlphaGoat02.vue";
import AlphaGoat03 from "@/pages/AlphaGoat/AlphaGoat03.vue";
import AlphaGoat04 from "@/pages/AlphaGoat/AlphaGoat04.vue";
import HomePage from "@/pages/AlphaGoatClub/HomePage.vue";
import WhoAlphaLabs00 from "@/pages/AlphaLabs/WhoAlphaLabs00.vue";
import WhoAlphaLabs01 from "@/pages/AlphaLabs/WhoAlphaLabs01.vue";
import WhoAlphaLabs02 from "@/pages/AlphaLabs/WhoAlphaLabs02.vue";
import MorePerks00 from "@/pages/Contribution/MorePerks00.vue";
import MorePerks01 from "@/pages/Contribution/MorePerks01.vue";
import SurveyPage01 from "@/pages/Contribution/SurveyPage01.vue";
import SurveyPage02 from "@/pages/Contribution/SurveyPage02.vue";
import SurveyPage03 from "@/pages/Contribution/SurveyPage03.vue";
import SurveyPage04 from "@/pages/Contribution/SurveyPage04.vue";
import SurveyPage05 from "@/pages/Contribution/SurveyPage05.vue";
import SurveyPage06 from "@/pages/Contribution/SurveyPage06.vue";
import SurveyPage07 from "@/pages/Contribution/SurveyPage07.vue";
import SurveyPage08 from "@/pages/Contribution/SurveyPage08.vue";
import SurveyPage09 from "@/pages/Contribution/SurveyPage09.vue";
import SurveyPage10 from "@/pages/Contribution/SurveyPage10.vue";
import SurveyPage11 from "@/pages/Contribution/SurveyPage11.vue";
import SurveyPageEnd from "@/pages/Contribution/SurveyPageEnd.vue";
import GemMechanism01 from "@/pages/GEMMechanism/GemMechanism01.vue";
import GemMechanism02 from "@/pages/GEMMechanism/GemMechanism02.vue";
import GemMechanism03 from "@/pages/GEMMechanism/GemMechanism03.vue";
import GemMechanism04 from "@/pages/GEMMechanism/GemMechanism04.vue";
import GemMechanism05 from "@/pages/GEMMechanism/GemMechanism05.vue";
import GemMechanism06 from "@/pages/GEMMechanism/GemMechanism06.vue";
import GemMechanism07 from "@/pages/GEMMechanism/GemMechanism07.vue";
import GemMechanism08 from "@/pages/GEMMechanism/GemMechanism08.vue";
import GemMechanism09Lose from "@/pages/GEMMechanism/GemMechanism09Lose.vue";
import GemMechanism09Win from "@/pages/GEMMechanism/GemMechanism09Win.vue";
import GemMechanism10Lose from "@/pages/GEMMechanism/GemMechanism10Lose.vue";
import GemMechanism10Win from "@/pages/GEMMechanism/GemMechanism10Win.vue";
import GemMechanism11 from "@/pages/GEMMechanism/GemMechanism11.vue";
import GemMechanism12 from "@/pages/GEMMechanism/GemMechanism12.vue";
import GemMechanism13 from "@/pages/GEMMechanism/GemMechanism13.vue";
import GemMechanism14 from "@/pages/GEMMechanism/GemMechanism14.vue";
import GemMechanism15 from "@/pages/GEMMechanism/GemMechanism15.vue";
import GemMechanism16 from "@/pages/GEMMechanism/GemMechanism16.vue";
import HonoraryInvitations00 from "@/pages/HonoraryInvitations/HonoraryInvitations00.vue";
import HonoraryInvitations01 from "@/pages/HonoraryInvitations/HonoraryInvitations01.vue";
import RewardsView from "@/pages/Rewards/RewardsView.vue";
import TestPage from "@/pages/Test/TestPage.vue";
import TestPage2 from "@/pages/Test/TestPage2.vue";
import TestPage3 from "@/pages/Test/TestPage3.vue";
import TestPage4 from "@/pages/Test/TestPage4.vue";


export default {
  'AlphaGoat01': {category: 'Alpha G.O.A.T', component: AlphaGoat01, name: 'AlphaGoat01'},
  'AlphaGoat01S2': {category: 'Alpha G.O.A.T', component: AlphaGoat01S2, name: 'AlphaGoat01S2'},
  'AlphaGoat01S3': {category: 'Alpha G.O.A.T', component: AlphaGoat01S3, name: 'AlphaGoat01S3'},
  'AlphaGoat01S4': {category: 'Alpha G.O.A.T', component: AlphaGoat01S4, name: 'AlphaGoat01S4'},
  'AlphaGoat01Tiers': {category: 'Alpha G.O.A.T', component: AlphaGoat01Tiers, name: 'AlphaGoat01Tiers'},
  'AlphaGoat02': {category: 'Alpha G.O.A.T', component: AlphaGoat02, name: 'AlphaGoat02'},
  'AlphaGoat03': {category: 'Alpha G.O.A.T', component: AlphaGoat03, name: 'AlphaGoat03'},
  'AlphaGoat04': {category: 'Alpha G.O.A.T', component: AlphaGoat04, name: 'AlphaGoat04'},
  'HomePage': {category: 'Alpha G.O.A.T Club', component: HomePage, name: 'HomePage'},
  'WhoAlphaLabs00': {category: 'Alpha Labs', component: WhoAlphaLabs00, name: 'WhoAlphaLabs00'},
  'WhoAlphaLabs01': {category: 'Alpha Labs', component: WhoAlphaLabs01, name: 'WhoAlphaLabs01'},
  'WhoAlphaLabs02': {category: 'Alpha Labs', component: WhoAlphaLabs02, name: 'WhoAlphaLabs02'},
  'MorePerks00': {category: 'Contribution', component: MorePerks00, name: 'MorePerks00'},
  'MorePerks01': {category: 'Contribution', component: MorePerks01, name: 'MorePerks01'},
  'SurveyPage01': {category: 'Contribution', component: SurveyPage01, name: 'SurveyPage01'},
  'SurveyPage02': {category: 'Contribution', component: SurveyPage02, name: 'SurveyPage02'},
  'SurveyPage03': {category: 'Contribution', component: SurveyPage03, name: 'SurveyPage03'},
  'SurveyPage04': {category: 'Contribution', component: SurveyPage04, name: 'SurveyPage04'},
  'SurveyPage05': {category: 'Contribution', component: SurveyPage05, name: 'SurveyPage05'},
  'SurveyPage06': {category: 'Contribution', component: SurveyPage06, name: 'SurveyPage06'},
  'SurveyPage07': {category: 'Contribution', component: SurveyPage07, name: 'SurveyPage07'},
  'SurveyPage08': {category: 'Contribution', component: SurveyPage08, name: 'SurveyPage08'},
  'SurveyPage09': {category: 'Contribution', component: SurveyPage09, name: 'SurveyPage09'},
  'SurveyPage10': {category: 'Contribution', component: SurveyPage10, name: 'SurveyPage10'},
  'SurveyPage11': {category: 'Contribution', component: SurveyPage11, name: 'SurveyPage11'},
  'SurveyPageEnd': {category: 'Contribution', component: SurveyPageEnd, name: 'SurveyPageEnd'},
  'GemMechanism01': {category: 'GEM Protocol', component: GemMechanism01, name: 'GemMechanism01'},
  'GemMechanism02': {category: 'GEM Protocol', component: GemMechanism02, name: 'GemMechanism02'},
  'GemMechanism03': {category: 'GEM Protocol', component: GemMechanism03, name: 'GemMechanism03'},
  'GemMechanism04': {category: 'GEM Protocol', component: GemMechanism04, name: 'GemMechanism04'},
  'GemMechanism05': {category: 'GEM Protocol', component: GemMechanism05, name: 'GemMechanism05'},
  'GemMechanism06': {category: 'GEM Protocol', component: GemMechanism06, name: 'GemMechanism06'},
  'GemMechanism07': {category: 'GEM Protocol', component: GemMechanism07, name: 'GemMechanism07'},
  'GemMechanism08': {category: 'GEM Protocol', component: GemMechanism08, name: 'GemMechanism08'},
  'GemMechanism09Lose': {category: 'GEM Protocol', component: GemMechanism09Lose, name: 'GemMechanism09Lose'},
  'GemMechanism09Win': {category: 'GEM Protocol', component: GemMechanism09Win, name: 'GemMechanism09Win'},
  'GemMechanism10Lose': {category: 'GEM Protocol', component: GemMechanism10Lose, name: 'GemMechanism10Lose'},
  'GemMechanism10Win': {category: 'GEM Protocol', component: GemMechanism10Win, name: 'GemMechanism10Win'},
  'GemMechanism11': {category: 'GEM Protocol', component: GemMechanism11, name: 'GemMechanism11'},
  'GemMechanism12': {category: 'GEM Protocol', component: GemMechanism12, name: 'GemMechanism12'},
  'GemMechanism13': {category: 'GEM Protocol', component: GemMechanism13, name: 'GemMechanism13'},
  'GemMechanism14': {category: 'GEM Protocol', component: GemMechanism14, name: 'GemMechanism14'},
  'GemMechanism15': {category: 'GEM Protocol', component: GemMechanism15, name: 'GemMechanism15'},
  'GemMechanism16': {category: 'GEM Protocol', component: GemMechanism16, name: 'GemMechanism16'},
  'HonoraryInvitations00': {category: 'Honorary Invitations', component: HonoraryInvitations00, name: 'HonoraryInvitations00'},
  'HonoraryInvitations01': {category: 'Honorary Invitations', component: HonoraryInvitations01, name: 'HonoraryInvitations01'},
  'RewardsView': {category: 'Rewards', component: RewardsView, name: 'RewardsView'},
  'TestPage': {category: 'Test', component: TestPage, name: 'TestPage'},
  'TestPage2': {category: 'Test', component: TestPage2, name: 'TestPage2'},
  'TestPage3': {category: 'Test', component: TestPage3, name: 'TestPage3'},
  'TestPage4': {category: 'Test', component: TestPage4, name: 'TestPage4'},
};